const isInvalidRefreshTokenError = ({ status, data, request } = {}) => (
    request?.grant_type === 'refresh_token' &&
    status === 400 &&
    data?.error === 'invalid_grant'
);

export default isInvalidRefreshTokenError;
